<div class="recently-broken-records--sponsor-fit">
  <h2>{{'recently_broken_records' | transloco}}</h2>
  <table class="recently-broken-records">
    <tr *ngFor="let broken of RecordsList" class="recently-broken-records__row">
      <td class="recently-broken-records__athlete recently-broken-records__cell">
        <div >
        <ng-container *ngFor="let athlete of broken.athlete">
        <a
          [href]="lang +'profile/'+athlete.id.toString()"
          *ngIf="broken.isTeam===false; else team"
          class="recently-broken-records__athlete__link"
          data-th="name"
          >
          <span
            [ngClass]="athlete.wNameOrd === 1 ? 'recently-broken-records__athlete__lastname' : 'recently-broken-records__athlete__name'"
            >
            {{
              athlete.wNameOrd === 1
                ? athlete.fName
                : athlete.gName
            }}</span>
          <span
            [ngClass]="athlete.wNameOrd === 0 ? 'recently-broken-records__athlete__lastname' : 'recently-broken-records__athlete__name'"
            >
            {{
              athlete.wNameOrd === 0
                ? athlete.fName
                : athlete.gName
            }}</span>
          <img class="recently-broken-records__athlete__flag" *ngIf="athlete.noc!==undefined"
            [lazyLoad]="
            '//extranet.worldarchery.sport/Flags/' +
            athlete.noc +
            '.svg'
            "
          />
        </a>
        <ng-template #team>
          <a
            *ngFor="let athlete of broken.athlete"
            class="recently-broken-records__athlete__link"
            data-th="name"
            >
            <span
             [ngClass]="'recently-broken-records__athlete__name'"
              >
              {{
                athlete.fName


              }}
            </span>
            <img class="recently-broken-records__athlete__flag" *ngIf="athlete.noc!==undefined"
              [lazyLoad]="
              '//extranet.worldarchery.sport/Flags/' +
              athlete.noc +
              '.svg'
              "
            />
          </a>

        </ng-template>
      </ng-container>

      </div>

        <div class="recently-broken-records__record-name">{{broken.name}} - {{broken.subname}}</div>
        <div class="recently-broken-records__record-category">{{getCategoryName(broken.catCode)}}</div>

      </td>
      <td class="recently-broken-records__record-date recently-broken-records__cell">{{broken.date|date : 'd LLLL yyyy'}}</td>
      <td class="recently-broken-records__record-points recently-broken-records__cell">
          <span>{{broken.points}}  </span>

      </td>
      <td class="recently-broken-records__record-points recently-broken-records__cell">
        <span class="recently-broken-records__difference" *ngIf="broken.points-broken.prevPoints !== 0">+{{broken.points - broken.prevPoints}}</span>
      </td>
    </tr>

  </table>
</div>
